export const initFormSubmitLock = () => {
  const forms = document.querySelectorAll(".wpcf7 form");

  if (!forms.length) return;

  const wrapSubmitAndSpinner = (form) => {
    const submitControls = form.querySelectorAll(".wpcf7-submit");

    submitControls.forEach((submitControl) => {
      const parent = submitControl.parentElement;
      if (!parent) return;
      if (parent.classList.contains("wpcf7-submit-wrapper")) return;

      const spinner = submitControl.nextElementSibling?.classList.contains(
        "wpcf7-spinner",
      )
        ? submitControl.nextElementSibling
        : null;

      const wrapper = document.createElement("div");
      wrapper.className = "wpcf7-submit-wrapper";

      parent.insertBefore(wrapper, submitControl);
      wrapper.appendChild(submitControl);

      if (spinner) {
        wrapper.appendChild(spinner);
      }
    });
  };

  const toggleSubmitState = (form, isSubmitting) => {
    const submitControls = form.querySelectorAll(
      'button[type="submit"], input[type="submit"]',
    );

    submitControls.forEach((control) => {
      control.classList.toggle("is-submitting", isSubmitting);
    });
  };

  forms.forEach((form) => {
    wrapSubmitAndSpinner(form);

    form.addEventListener("submit", () => {
      toggleSubmitState(form, true);
    });
  });

  const releaseEvents = [
    "wpcf7invalid",
    "wpcf7mailsent",
    "wpcf7mailfailed",
    "wpcf7spam",
    "wpcf7submit",
  ];

  releaseEvents.forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const form = event.target?.querySelector("form") ?? event.target;

      if (form instanceof HTMLFormElement) {
        wrapSubmitAndSpinner(form);
        toggleSubmitState(form, false);
      }
    });
  });
};
